export default "__VITE_ASSET__DiCRG7is__"